


























































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

@Component
export default class AddCustomBillingTermModal extends Mixins(HasValidation) {
  @Prop({ required: true })
  public usedBillingTerms!: number[];

  public customValue = 1;

  public get customValueIsDisabled() {
    return (
      this.usedBillingTerms.includes(this.customValue) || this.customValue === 0
    );
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      this.$emit("success", this.customValue);
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
